<template>
  <g>
    <g clip-path="url(#clip0_15_1087)">
      <path
        d="M18.11 1.77017L19.07 0.810175C19.1625 0.717471 19.2724 0.643924 19.3934 0.593742C19.5143 0.543561 19.644 0.517731 19.775 0.517731C19.906 0.517731 20.0357 0.543561 20.1566 0.593742C20.2776 0.643924 20.3875 0.717471 20.48 0.810175L21.19 1.52017C21.58 1.91017 21.58 2.54017 21.19 2.93017L20.23 3.89017L18.11 1.77017ZM17.11 2.77017L19.23 4.89017L13.26 10.8602C13.1671 10.9535 13.0417 11.0072 12.91 11.0102H11.5C11.22 11.0102 11 10.7902 11 10.5102V9.10017C11 8.97017 11.05 8.84017 11.15 8.75017L17.11 2.77017ZM15.13 2.64017L9.79 7.98018C9.61 8.17018 9.5 8.42017 9.5 8.69017V11.5202C9.5 12.0702 9.95 12.5202 10.5 12.5202H13.33C13.6 12.5202 13.85 12.4102 14.04 12.2302L19.37 6.90018C19.77 7.88018 20 8.99017 20 10.2102C20 13.3902 17.55 17.1302 12.66 21.4402C12.28 21.7702 11.71 21.7702 11.33 21.4402C6.45 17.1302 4 13.3902 4 10.2102C4 5.23017 7.8 2.01017 12 2.01017C13.09 2.01017 14.16 2.23017 15.13 2.64017Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_1087">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
